export default {
  FETCH_DASHBOARD_DATA_SUCCESS: 'FETCH_DASHBOARD_DATA_SUCCESS',
  FETCH_DASHBOARD_DATA_LOADING: 'FETCH_DASHBOARD_DATA_LOADING',
  FETCH_DASHBOARD_DATA_REJECT: 'FETCH_DASHBOARD_DATA_REJECT',
  FETCH_DASHBOARD_DATA_FAILED: 'FETCH_DASHBOARD_DATA_FAILED',


  FETCH_CAFE_ADMIN_DASHBOARD_DATA_SUCCESS: 'FETCH_CAFE_ADMIN_DASHBOARD_DATA_SUCCESS',
  FETCH_CAFE_ADMIN_DASHBOARD_DATA_LOADING: 'FETCH_CAFE_ADMIN_DASHBOARD_DATA_LOADING',
  FETCH_CAFE_ADMIN_DASHBOARD_DATA_REJECT: 'FETCH_CAFE_ADMIN_DASHBOARD_DATA_REJECT',
  FETCH_CAFE_ADMIN_DASHBOARD_DATA_FAILED: 'FETCH_CAFE_ADMIN_DASHBOARD_DATA_FAILED',
}